import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function Unlock({ size, ...props }) {
  return (
    <SvgIconComponent
      height="97"
      width="96"
      fill="none"
      viewBox="0 0 96 97"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M48.4096 8.5C35.812 8.5 25.5996 19.0484 25.5996 32.0605V43.7002M48 8.5C60.5976 8.5 70.81 19.0484 70.81 32.0605V43.526M28.8 88.5002H67.2C74.2692 88.5002 80 82.7695 80 75.7002V50.1002C80 46.5656 77.1346 43.7002 73.6 43.7002H22.4C18.8654 43.7002 16 46.5656 16 50.1002V75.7002C16 82.7694 21.7308 88.5002 28.8 88.5002Z"
        stroke="#141A21"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M47.9998 68.9C51.9763 68.9 55.1998 65.6765 55.1998 61.7C55.1998 57.7235 51.9763 54.5 47.9998 54.5C44.0234 54.5 40.7998 57.7235 40.7998 61.7C40.7998 65.6765 44.0234 68.9 47.9998 68.9ZM47.9998 68.9L48 78.584"
        stroke="#141A21"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </SvgIconComponent>
  )
}

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}

Unlock.propTypes = iconPropTypes

const iconsOthers = {
  Unlock
}

export default iconsOthers
